import { _comment as _blockComment } from '../block/_comment'
import { RegexEditor } from '../utils/regex_editor'

export const _comment = new RegexEditor(_blockComment)
  .replace('(?:-->|$)', '-->')
  .getRegex()
